export default {
  REQUEST_FETCH_PAPERS: 'REQUEST_FETCH_PAPERS',
  FETCH_PAPERS_ERROR: 'FETCH_PAPERS_ERROR',
  FETCH_PAPERS_SUCCESS: 'FECTH_PAPERS_SUCCESS',
  FETCH_RESEARCHS_SUCCESS: 'FECTH_RESEARCHS_SUCCESS',
  FETCH_BOOKS_SUCCESS: 'FECTH_BOOKS_SUCCESS',
  FETCH_HKIS_SUCCESS: 'FECTH_HKIS_SUCCESS',
  RESET_PAPER: 'RESET_PAPER'
}
